// src/auth/RoleRoute.tsx
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context';

export interface RoleRouteProps {
  children: React.ReactNode;
  allowedRoles: string[];
}

const RoleRoute = ({ children, allowedRoles }: RoleRouteProps) => {
  const { user, role, isLoading, authReady } = useAuth() as {
    user: { uid: string; displayName?: string; email?: string } | null;
    role: string | null;
    isLoading: boolean;
    authReady: boolean;
  };

  // Still loading
  if (isLoading || !authReady) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <p className="text-slate-500 dark:text-slate-400">Validating access...</p>
      </div>
    );
  }

  // No user or no role found
  if (!user || !role) {
    return <Navigate to="/login" replace />;
  }

  // Not authorized
  if (!allowedRoles.includes(role)) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <p className="text-red-600 text-lg font-semibold">Access Denied</p>
      </div>
    );
  }

  // Authorized
  return children;
};

export default RoleRoute;
